import script from "./BaseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=4f756f74&scoped=true&lang=scss"
script.__scopeId = "data-v-4f756f74"

export default script